import React, { ChangeEvent } from 'react';
import {
  Grid,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import {
  IconContainer,
  StyledMenu,
  Container,
} from 'components/NavBarLogin/styles';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'helpers/intl';
import messages from 'containers/NavBarDashboard/messages';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import Logo from 'containers/NavBarDashboard/Logo';
import { useSelector, useDispatch } from 'react-redux';
import { upperCase } from 'lodash';
import { StyledLanguageButton } from 'containers/NavBarDashboard/styles';
import { Captions } from 'components/Typography';
import { changeLocaleLanguage } from 'store/LanguageProvider/actions';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { useRouteMatch } from 'react-router';
import pages from 'routes/pages';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { useLocation } from 'react-router-dom';

const NavBarLogin = (props: { intl: IntlShape }) => {
  const route = useRouteMatch();
  const [
    anchorLanguage,
    setAnchorLanguage,
  ] = React.useState<null | HTMLElement>(null);
  const dispatch = useDispatch();
  const language = useSelector(getLocaleSelector);
  const handleClickLanguageMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorLanguage(event.currentTarget);
  };
  const handleCloseLanguageMenu = () => {
    setAnchorLanguage(null);
  };

  const handleChangeLanguage = (
    e: ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    if (route.path === pages.LOGIN) {
      GATracking.event(
        EVENT_CATEGORIES.LOGIN,
        EVENT_ACTION.CLICK,
        'changer la langue',
      );
      if (value === LANGUAGES.AR) {
        GATracking.event(
          EVENT_CATEGORIES.LOGIN,
          EVENT_ACTION.CLICK,
          'Bouton Arabe',
        );
      }
      if (value === LANGUAGES.FR) {
        GATracking.event(
          EVENT_CATEGORIES.LOGIN,
          EVENT_ACTION.CLICK,
          'Bouton Français',
        );
      }
    }
    dispatch(changeLocaleLanguage(value));
    handleCloseLanguageMenu();
  };

  const location = useLocation();
  const handleLogoClick = () => {
    /* istanbul ignore next */
    if (location.pathname === pages.SIGNUP)
      localStorage.removeItem('personalInfo');
  };

  return (
    <>
      <Container container justify="flex-start" alignItems="flex-start">
        <IconContainer item xs={9} sm={10} onClick={handleLogoClick}>
          <Logo />
        </IconContainer>
        <Grid item xs={3} sm={2}>
          <StyledLanguageButton
            onClick={handleClickLanguageMenu}
            variant="contained"
            aria-controls="language-menu"
          >
            <img src={get(AssuranceIcon, 'globe')} alt="globe-icon" />
            <Captions>{upperCase(language)}</Captions>
            <img src={get(AssuranceIcon, 'caretDown')} alt="caret-down-icon" />
          </StyledLanguageButton>
          <StyledMenu
            id="language-menu"
            anchorEl={anchorLanguage}
            open={Boolean(anchorLanguage)}
            onClose={handleCloseLanguageMenu}
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="language-radio-group"
                name="language"
                value={language}
                data-testid="language-radio-group"
                onChange={handleChangeLanguage}
              >
                <MenuItem>
                  <FormControlLabel
                    value={LANGUAGES.FR}
                    control={<Radio />}
                    label={translate(get(messages, 'french'), props)}
                  />
                </MenuItem>
                <MenuItem>
                  <FormControlLabel
                    value={LANGUAGES.AR}
                    control={<Radio />}
                    label={translate(get(messages, 'arabic'), props)}
                  />
                </MenuItem>
              </RadioGroup>
            </FormControl>
          </StyledMenu>
        </Grid>
      </Container>
    </>
  );
};

export default injectIntl(NavBarLogin);
